import type {
  FlattenedNode,
  GicsLevel,
  GicsTreeNode,
  SelectedIndustry,
} from "./types";

export function flattenTree(
  nodes: GicsTreeNode[],
  ancestors: string[] = [],
): FlattenedNode[] {
  const result: FlattenedNode[] = [];

  for (const node of nodes) {
    result.push({
      id: node.id,
      code: node.code,
      name: node.name,
      level: node.level,
      breadcrumb: ancestors.join(" › "),
    });

    if (node.children && node.children.length > 0) {
      result.push(...flattenTree(node.children, [...ancestors, node.name]));
    }
  }

  return result;
}

export function searchTree(
  nodes: FlattenedNode[],
  query: string,
): FlattenedNode[] {
  const lowerQuery = query.toLowerCase();
  return nodes
    .filter(
      (node) =>
        node.name.toLowerCase().includes(lowerQuery) ||
        node.code.toLowerCase().includes(lowerQuery),
    )
    .slice(0, 15);
}

export function findPathToNode(
  nodes: GicsTreeNode[],
  targetId: string,
  path: string[] = [],
): string[] | null {
  for (const node of nodes) {
    if (node.id === targetId) {
      return path;
    }
    if (node.children && node.children.length > 0) {
      const result = findPathToNode(node.children, targetId, [
        ...path,
        node.id,
      ]);
      if (result) return result;
    }
  }
  return null;
}

const LEVEL_MAP: Record<string, GicsLevel> = {
  sector: 1,
  industry_group: 2,
  industry: 3,
  sub_industry: 4,
};

export function parseIndustryParam(
  param: string | null,
): SelectedIndustry | null {
  if (!param) return null;

  const [type, id] = param.split("-");
  if (!type || !id) return null;

  const level = LEVEL_MAP[type];
  if (!level) return null;

  return {
    id: param,
    name: "",
    level,
  };
}

export function findNodeById(
  nodes: GicsTreeNode[],
  targetId: string,
): GicsTreeNode | null {
  for (const node of nodes) {
    if (node.id === targetId) return node;
    if (node.children) {
      const found = findNodeById(node.children, targetId);
      if (found) return found;
    }
  }
  return null;
}
